import './index.scss';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {Button, Popconfirm,Popover, Input, Card, Breadcrumb, Icon, message, Pagination, Table, Modal} from 'antd';
import moment from 'moment';
import Info from '../Detail/Info';
import ajaxUtil from '../../util/ajax';

const {ajax, ajaxv2, DOMAIN_CURRENT} = ajaxUtil;

const AddDocument = (props)=>{
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState(null);
  const {videoList} = props;

  useEffect(()=>{
    setVisible(!!props.data);

    if(props.data) {
      setData(props.data);
    }
  }, [props.data]);

  return <Modal visible={visible} title={data && data.id ? "编辑文件" : "新增文件"} centered={true} maskClosable={false} onCancel={()=>{
    props.onCancel && props.onCancel();
  }} onOk={()=>{
    props.onSubmit && props.onSubmit(data);
  }}>
    <div className="wrapper">
      <Info useLabel={false} value={<p style={{fontSize:12,marginLeft:105,marginBottom:0}}>文件最大支持100M，目前仅支持PDF格式，后续开放支持Doc以及PPT格式</p>} isText={true} />
      <Info label="上传文件" value={data ? data.doc_origin : null} type="file" limitSize={100} onChange={(a, b)=>{
        let result = {
          doc_origin:a
        };
        if(data && !data.doc_name) {
          result.doc_name = b.name;
        }
        setData({
          ...data,
          ...result
        });
      }} />
      <Info label="文件名" value={data ? data.doc_name : ''} onChange={(e)=>{
        setData({
          ...data,
          doc_name:e
        });
      }} />
      <Info label="绑定视频" type="select" value={data ? String(data.medium_id) : null} width={200} data={[{key:'0',name:'无'}].concat(videoList.map(it=>({
        key:String(it.id),
        name:it.desc
      })))} onChange={(e)=>{
        setData({
          ...data,
          medium_id:e
        });
      }} />
    </div>
  </Modal>
};

export default AddDocument;



// WEBPACK FOOTER //
// ./src/components/Document/AddDocument.js